// plugins/collectionStoragePlugin.js

import CollectionStorageManager from "@/utils/collectionStorageManager";

/**
 * Plugin Vue pour la gestion automatique du localStorage des collections
 * S'intègre avec Vue Router pour nettoyer automatiquement lors des navigations
 */
export default {
  install(Vue, { router } = {}) {
    // Ajouter le gestionnaire comme propriété globale
    Vue.prototype.$collectionStorage = CollectionStorageManager;

    // Intégration avec Vue Router si fourni
    if (router) {
      // Guard global pour détecter les sorties du workflow
      router.beforeEach((to, from, next) => {
        try {
          // Nettoyer si on sort du workflow collections
          const wasCleared = CollectionStorageManager.handleRouteChange(to, from);

          if (wasCleared) {
            console.log(
              "🧹 Nettoyage automatique effectué lors de la navigation"
            );
          }

          next();
        } catch (error) {
          console.error("Erreur dans le guard de navigation:", error);
          next();
        }
      });

      // Optionnel: nettoyage au refresh/fermeture de page
      window.addEventListener("beforeunload", () => {
        // Vérifier si on est sur une page du workflow
        const currentRoute = router.currentRoute;

        if (
          !CollectionStorageManager.isCollectionWorkflowRoute(
            currentRoute?.name
          )
        ) {
          CollectionStorageManager.clearAll();
        }
      });
    }

    // Mixin global pour les méthodes de nettoyage
    Vue.mixin({
      methods: {
        /**
         * Nettoie le localStorage des collections avec contexte
         * @param {String} context - Contexte du nettoyage
         */
        clearCollectionStorage(context = "manual") {
          this.$collectionStorage.clearForContext(context);
        },

        /**
         * Vérifie si on est dans le workflow collections
         */
        isInCollectionWorkflow() {
          return this.$collectionStorage.isCollectionWorkflowRoute(
            this.$route?.name
          );
        },

        /**
         * Debug rapide du localStorage
         */
        debugCollectionStorage() {
          this.$collectionStorage.debugCurrentState();
        },
      },
    });

    // Méthodes statiques accessibles globalement
    Vue.CollectionStorage = CollectionStorageManager;
  },
};
